import ProductStore from "./ProductStore";
import ProductViewStore from "./ProductViewStore";
import ProductManagementStore from "./ProductManagement/ProductManagement.Store";
import ProductCategoriesStore from "./ProductCategories/ProductCategories.Store";
import { DrawingManagementStore } from "./DrawingManagement/DrawingManagementStore";

const productStoreList = [
    { name: "productStore", store: ProductStore },
    { name: "productViewStore", store: ProductViewStore },
    { name: "productManagementStore", store: ProductManagementStore },
    { name: "productCategoriesStore", store: ProductCategoriesStore },
    { name: "drawingManagementStore", store: DrawingManagementStore },
];

export default productStoreList;
